// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../app/design/frontend/Netlogiq/farmec/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Logo{--placeholder-image: none;--placeholder-animation: none;--image-default-background: #fff;height:100%}.Logo-Placeholder{position:absolute;left:0;right:0;bottom:0;top:0;margin:auto}.Logo-Accent{fill:var(--primary-base-color)}\n", ""]);
// Exports
module.exports = exports;
